import { render } from "./FactorsReport.vue?vue&type=template&id=a39df088"
import script from "./FactorsReport.vue?vue&type=script&lang=js"
export * from "./FactorsReport.vue?vue&type=script&lang=js"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__